import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminState } from './admin.reducers';

const getAdminsState = createFeatureSelector<AdminState>('admins');

const getIsFetching = createSelector(getAdminsState, (state: AdminState) => state.isFetching);
const getAdmins = createSelector(getAdminsState, (state: AdminState) => state.admins);

export const adminsQuery = {
  getIsFetching,
  getAdmins
}